///
/// EarthBrowser
///
/// Migration v49 to v50: Remove the clock loop / fit-to-data options
/// Created by Matt Giger on 10/11/2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v49 to v50
 *
 * Changes:
 * - Drops earthbrowser.clockLoop and earthbrowser.clockFitToData. Looping
 *   is now always on and the fit-to-data option was removed with its UI.
 */
export function migrateV49toV50(state: unknown): unknown {
	const s = state as Record<string, unknown> | null | undefined
	if (!s || typeof s !== "object" || !s.earthbrowser) return state

	const eb = { ...(s.earthbrowser as Record<string, unknown>) }
	delete eb.clockLoop
	delete eb.clockFitToData
	return { ...s, earthbrowser: eb }
}
